import createCollectionStoreClass from './lib/create_collection_store_class';
import createConverter from 'scripts/adapters/immutable_converters/lib/create_converter';
import RoutingGroup from 'models/routing_group';

const RoutingGroupsStore = createCollectionStoreClass({
  converter: createConverter(RoutingGroup),
});

export default RoutingGroupsStore;
